/**
 * Vertragsmanagement API
 * REST-Api für das Conergos Vertragsmanagement Tool.
 *
 * OpenAPI spec version: 0.1.0
 * Contact: marius.junak@scorpius-forge.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Configuration } from '../configuration';
import { OrderDto } from '@bo-client/shared/models/orderDto';
import { OrderRequestDto } from '@bo-client/shared/models/orderRequestDto';
import { ConfigService } from '@bo-client/config/config.service';

@Injectable()
export class OrderRequestManagementService {
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() configuration: Configuration,
    private configService: ConfigService
  ) {}

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * getContracts
   * gets all the contract offers of the specified tenant
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

  public getOrders(observe: any = 'body', reportProgress = false): Observable<any> {
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    return this.httpClient.get<Array<OrderDto>>(`${this.configService.getSettings('serverUrl')}/orders/all`, {
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress
    });
  }

  public getOrder(orderId?: number, observe: any = 'body', reportProgress = false): Observable<any> {
    let queryParameters = new HttpParams();
    if (orderId !== undefined) {
      queryParameters = queryParameters.set('orderId', <any>orderId);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    return this.httpClient.get<OrderDto>(
      `${this.configService.getSettings('serverUrl')}/orders/${encodeURIComponent(String(orderId))}`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  sendToBilling(orderId: number, sendConfirmationMail: boolean): Observable<OrderRequestDto> {
    let queryParameters = new HttpParams();
    if (orderId !== undefined) {
      queryParameters = queryParameters.set('orderId', <any>orderId);
      queryParameters = queryParameters.set('sendConfirmationMail', <any>sendConfirmationMail);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    return this.httpClient.post<OrderRequestDto>(
      `${this.configService.getSettings('serverUrl')}/orders/${encodeURIComponent(
        String(orderId)
      )}/sendToBilling`,
      {},
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers
      }
    );
  }

  resendMail(orderId: number): Observable<OrderRequestDto> {
    let queryParameters = new HttpParams();
    if (orderId !== undefined) {
      queryParameters = queryParameters.set('orderId', <any>orderId);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    return this.httpClient.post<OrderRequestDto>(
      `${this.configService.getSettings('serverUrl')}/orders/${encodeURIComponent(
        String(orderId)
      )}/resendMail`,
      {},
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers
      }
    );
  }

  requestConfirmation(orderId: number, message: string): Observable<OrderRequestDto> {
    const queryParameters = new HttpParams();
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    const body = {
      orderRequestId: orderId,
      message: message
    };

    return this.httpClient.post<OrderRequestDto>(
      `${this.configService.getSettings('serverUrl')}/orders/requestOnlineConfirmation`,
      body,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers
      }
    );
  }

  putOrder(orderId: number, order: OrderRequestDto): Observable<OrderDto> {
    let queryParameters = new HttpParams();
    if (orderId !== undefined) {
      queryParameters = queryParameters.set('orderId', <any>orderId);
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    return this.httpClient.put<OrderDto>(
      `${this.configService.getSettings('serverUrl')}/orders/${encodeURIComponent(String(orderId))}`,
      order,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers
      }
    );
  }

  deleteOrder(orderId: number): Observable<OrderDto> {
    const queryParameters = new HttpParams();
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
      headers = headers.set('Content-Type', 'application/json');
    }
    return this.httpClient.delete<OrderDto>(
      `${this.configService.getSettings('serverUrl')}/orders/${encodeURIComponent(String(orderId))}`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers
      }
    );
  }

  createAndAttachConfirmation(orderId: number): Observable<OrderRequestDto> {
    const queryParameters = new HttpParams();
    let headers = this.defaultHeaders;

    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];

    const body = {};

    return this.httpClient.post<OrderRequestDto>(
      `${this.configService.getSettings('serverUrl')}/orders/${orderId}/create-and-attach-confirmation`,
      body,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers
      }
    );
  }
}
